import type { BrandTheme, PartialBrandTheme } from '../../types/BrandTheme'
import { merge } from 'theme-ui'
import { dirname } from 'path'
import { elkjoptheme } from '../elkjop/elkjop.theme'

import './theme.css'

export const elkotheme: BrandTheme = merge.all<BrandTheme, PartialBrandTheme>(
  elkjoptheme,
  {
    branding: {
      brand: 'ELKO',
      themedir: dirname(new URL(import.meta.url).pathname),
      staticDir: 'elko',
      height: 32,
    },
  },
)
export default elkotheme
